import { pubsub } from '@services';

class SortBy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => this.updateSortElements(event));
    this.defaultSortBy = this.getAttribute('data-sort-by-default');

    // The quick-filter chips can carry `sort_by` and change the URL without a
    // reload. Left alone the select kept showing the old value — and picking
    // that value back was then a no-op, because the value had not changed, so
    // no `change` fired and the customer could not get the sort off again.
    // Reading the URL back covers every publisher, not just the chips. (NGE-11501)
    this.onUrlChange = () => this.syncFromURL();
    window.addEventListener('popstate', this.onUrlChange);
    this.unsubscribeFiltersUpdated = pubsub.subscribe('filters:updated', this.onUrlChange);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onUrlChange);
    this.unsubscribeFiltersUpdated?.();
  }

  /**
   * Point the select at whatever the URL currently says, falling back to the
   * collection's own default when `sort_by` has been cleared.
   */
  syncFromURL() {
    const select = this.querySelector('select');
    if (!select) return;

    const sortBy = new URLSearchParams(window.location.search).get('sort_by');
    select.value = sortBy || this.defaultSortBy || select.value;
  }

  /**
   * Update sort elements
   * @param {Object} event - Change event
   * @param {Object} event.target - Change event target
   *
   * @description Update all collection sort elements when the sort is changed
   */
  updateSortElements({ target: { value } }) {
    this.sortElements = this.sortElements || document.querySelectorAll('sort-by');

    // The 'element' variable is the current collection sort element. E.g. <sort-by>
    this.sortElements.forEach((element) => {
      // The 'select' variable is the select element inside the current collection sort element
      const select = element.querySelector('select');
      select.value = value;

      // Update the URL hash
      element.updateURL(value);
    });

    pubsub.publish('sort:changed', {
      value,
    });
  }

  /**
   * Update URL
   * @param {String} value - URL value
   */
  updateURL(value) {
    const { searchParams } = new URL(window.location);
    searchParams.set('sort_by', value);
    searchParams.delete('page');

    // if value = default, remove the sort_by parameter from the URL
    if (this.defaultSortBy && value === this.defaultSortBy) {
      searchParams.delete('sort_by');
    }

    const newUrl = searchParams.size
      ? `${window.location.pathname}?${searchParams}`
      : window.location.pathname;
    history.replaceState(null, '', newUrl);
  }
}

customElements.define('sort-by', SortBy);
